module.exports = __webpack_public_path__ + "img/img13.efaa362f.svg";